import { render } from "./TopCustomersTable.vue?vue&type=template&id=2610892a"
import script from "./TopCustomersTable.vue?vue&type=script&lang=js"
export * from "./TopCustomersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__